import React from 'react';
import {Form, FormGroup, Col, Row} from 'react-bootstrap';
import ReactTable from "react-table";
import "react-table/react-table.css";
import FontAwesome from 'react-fontawesome';
import constants from '../.././util/constants';
import downloadFile from 'react-file-download';
import axios from 'axios';
import './style.scss';
import LoadingSpinner from '../../LoadingSpinner';
import * as Grants from '../.././util/grants';
import { hasGrant } from '../.././util/grantHelper';
import * as Convert from '../../util/unitConversion';
import { Link } from 'react-router-dom'

const {API_BASE_URL} = constants;
const getFile = (apiToken, url, data) => {
    const header = {
        'Authorization': 'Bearer ' + apiToken,
        'Accept': 'application/pdf'
    };

    let fileName = '';
    //console.log("header:", header);
    if (url.indexOf('Invoice') > 0) {
        fileName = 'Invoice.pdf';
    } else if (url.indexOf('Packing') > 0) {
        fileName = 'PackingList.pdf'
    };
    axios
        .post(API_BASE_URL + url, data, {
        headers: header,
        responseType: 'blob'
    })
        .then(result => {
            downloadFile(result.data, fileName);
        })
        .catch(error => {
            alert("error:", error);
        });
}

class OrderInfo extends React.Component {
    getDate(date){
        if (date && date>'1950')
        {
            var newdate=new Date(date);
            return newdate.getFullYear()+'-'+(newdate.getMonth()+1).toString().padStart(2,'0')+'-'+newdate.getDate().toString().padStart(2,'0');
        }
        return '';
    }

    createFileList(apiToken, ordernum, orderpos, service, numbersAsString){
        if (!numbersAsString || numbersAsString.length < 1) {
            return 'missing'
        }
        
        return numbersAsString.map(n => {
            return (
                
                <div>{n.Title.includes('Invoice') ? n.Title.split("_")[2] : n.Title.split('_')[1]}
                    <FontAwesome
                        name="file-pdf-o"
                        className="text-danger handy"
                        onClick={() => {
                        getFile(apiToken, service, {
                            OrderNumber: ordernum,
                            OrderPos: orderpos,
                            FileNo: n.ReportDataId
                        });
                    }}/>
                </div>
            )
        });

        // <FontAwesome name="file-pdf-o" className="text-danger handy" onClick={() => {
        // getFile(this.props.apiToken,'Files/GetInvoice', { OrderNumber: ordernum,
        // OrderPos: orderpos }); } } />
    }

    render() {
        const data = this.props.orderInfo === undefined
            ? {}
            : this.props.orderInfo;
        if (this.props.orderInfo === undefined) {
            return (<LoadingSpinner isLoading={true}/>);
        } else {
            
            let ordernum = data.Header.ORDER_NUMBER;
            let orderpos = data.Detail.ORDER_ITEM_NUMBER;
            //console.log(data);
            // let invoiceList=data.Header.INVOICE_NO && data.Header.INVOICE_NO.length>1 ?
            // (<div>     {}     <FontAwesome name="file-pdf-o" className="text-danger
            // handy" onClick={() => { getFile(this.props.apiToken,'Files/GetInvoice', {
            // OrderNumber: ordernum, OrderPos: orderpos }); } } /> </div>) : 'mising';
            // console.log('data.Header',data.Header);
            return (
                <Col sm={10}>
                    <Form horizontal autoComplete="off" onSubmit={evt => {evt.preventDefault(); }}>
                        <FormGroup>
                            <Row className="row-eq-height">
                                <Col sm={3}>
                                    <Row>
                                        <Col xs={4}>Sales agent:</Col>
                                        <Col xs={8}>{data.Header.AGENT_SHORT_NAME}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Agent ref:</Col>
                                        <Col xs={8}>{data.Header.SALES_AGENT_REF}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Customer PO:</Col>
                                        <Col xs={8}>{data.Header.CUSTOMER_PO}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Customer:</Col>
                                        <Col xs={8}>{data.Header.CLIENT_CODE_REGIONAL + ' ' + data.Header.CUST_SHORT_NAME}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Bill to:</Col>
                                        <Col xs={8}>{data.Header.CONTACT_CODE_BILL_TO + ' ' + data.Header.BILL_SHORT_NAME}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Ship to:</Col>
                                        <Col xs={8}>{data.Header.CONTACT_CODE_SHIP_TO + ' ' + data.Header.SHIP_SHORT_NAME}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Delivery country:</Col>
                                        <Col xs={8}>{data.Header.DELIVERY_DESTINATION_COUNTRY}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Sold to:</Col>
                                        <Col xs={8}>{data.Header.CONTACT_CODE_SOLD_TO + ' ' + data.Header.SOLD_SHORT_NAME}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Currency code:</Col>
                                        <Col xs={8}>{data.Header.CURRENCY_CODE}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Delivery code:</Col>
                                        <Col xs={8}>{data.Header.DELIVERY_CODE}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Destination:</Col>
                                        <Col xs={8}>{data.Header.DELIVERY_DESTINATION}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>End user:</Col>
                                        <Col xs={8}>{data.Header.END_USER + ' ' + data.Header.END_USER_NAME}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Format unit:</Col>
                                        <Col xs={8}>{data.Header.FORMAT_UNIT}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Language code:</Col>
                                        <Col xs={8}>{data.Header.LANGUAGE_CODE}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Order comment:</Col>
                                        <Col xs={8}>{data.Header.AGENT_COMMENT}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Terms of payment:</Col>
                                        <Col xs={8}>{data.Header.TERMS_OF_PAYMENT_CODE}
                                            - {data.Header.TERMS_OF_PAYMENT_DESC}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>Cash discount rate:</Col>
                                        <Col xs={8}>{data.Header.CASH_DISCOUNT_RATE} {data.Header.CASH_DISCOUNT_RATE != null
                                                ? '%'
                                                : ''}</Col>
                                    </Row>
                                </Col>

                                <Col sm={3} className="left-border">
                                    <Row>
                                        <Col xs={6}>Description:</Col>
                                        <Col xs={6}>{data.Detail.ADESCRIPTION}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Delivery:</Col>
                                        <Col xs={6}>{data.Detail.DELIVERYTIME_TEXT}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Ordered by:</Col>
                                        <Col xs={6}>{data.Detail.ORDERED_BY}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Unit of quantity:</Col>
                                        <Col xs={6}>{data.Header.QUANTITY_UNIT_DESCRIPTION}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Weight:</Col>
                                        <Col xs={6}><Convert.AddUnit value={data.Detail.WEIGHT_UC} unit_metric={"kg"} unit_imperial={"lb"}/></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Price:</Col>
                                        <Col xs={6}>{data.Detail.UNIT_PRICE_COMMITTED}</Col>
                                    </Row>
                                    {hasGrant(Grants.TYPES.General_DownloadPackingAndInvoice) &&                                 
                                        <Row>
                                            <Col xs={6}>Invoice:</Col>
                                            <Col xs={6}>{this.createFileList(this.props.apiToken, ordernum, orderpos, 'Files/GetInvoice', data.Header.INVOICE_NO)}
                                            </Col>
                                        </Row>
                                    }
                                    {hasGrant(Grants.TYPES.General_DownloadPackingAndInvoice) &&                                 
                                        <Row className="row-eq-height">
                                            <Col xs={6}>Packing list:</Col>
                                            <Col xs={6}>{this.createFileList(this.props.apiToken, ordernum, orderpos, 'Files/GetPackingList', data.Header.LOADING_NO)}
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col xs={6}>Delivery week:</Col>
                                        <Col xs={6}>{data.Header.DELIVERYTIME_WEEK }</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Exmill:</Col>
                                        <Col xs={6}>{this.getDate(data.Header.EXMILL) }</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Ship no earlier:</Col>
                                        <Col xs={6}>{this.getDate(data.Header.SHIP_NO_EARLIER) }</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Ship no later:</Col>
                                        <Col xs={6}>{this.getDate(data.Header.SHIP_NO_LATER) }</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Date scheduled:</Col>
                                        <Col xs={6}>{this.getDate(data.Header.DATE_SCHEDULED) }</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Date promised:</Col>
                                        <Col xs={6}>{this.getDate(data.Header.DATE_PROMISED) }</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Actual shipment date:</Col>
                                        <Col xs={6}>{this.getDate(data.Header.SHIPMENT_DATE_ACT) }</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>Delivered:</Col>
                                        <Col xs={6}>{this.getDate(data.Header.DELIVERYTIME_DATE) }</Col>
                                    </Row>
                                </Col>
                                <Col sm={4}>
                                    {data.ItemTexts && data.ItemTexts.length > 0 && <ReactTable
                                        className="np-react-table"
                                        visible={false}
                                        showPagination={false}
                                        minRows={1}
                                        pageSize={100}
                                        data={data.ItemTexts}
                                        columns={[
                                        {
                                            Header: "Text content",
                                            accessor: "TEXT_CONTEXT",                                            
                                            Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                            headerStyle: {
                                                "textAlign": "left",
                                                "backgroundColor": "lightgray"
                                            }
                                        }, {
                                            Header: "Code",
                                            accessor: "TEXT_CODE",
                                            maxWidth: 60,
                                            headerStyle: {
                                                "textAlign": "left",
                                                "backgroundColor": "lightgray"
                                            }
                                        }, {
                                            Header: "Text type",
                                            accessor: "TEXT_TYPE",
                                            maxWidth: 60,
                                            headerStyle: {
                                                "textAlign": "left",
                                                "backgroundColor": "lightgray"
                                            }
                                        }, {
                                            Header: "Sort index",
                                            accessor: "SORT_INDEX",
                                            style: {
                                                "textAlign": "right"
                                            },
                                            maxWidth: 80,
                                            headerStyle: {
                                                "textAlign": "right",
                                                "backgroundColor": "lightgray"
                                            }
                                        }
                                    ]}
                                        defaultPageSize={5}/>}
                                    <br/> {data.ItemInstructions && data.ItemInstructions.length > 0 && <ReactTable
                                        className="np-react-table"
                                        showPagination={false}
                                        minRows={1}
                                        pageSize={100}
                                        data={data.ItemInstructions}
                                        columns={[
                                        {
                                            Header: "Instruction code",
                                            accessor: "INSTRUCTION_CODE",
                                            maxWidth: 100,
                                            headerStyle: {
                                                "textAlign": "left",
                                                "backgroundColor": "lightgray"
                                            }
                                        }, {
                                            Header: "Instruction note",
                                            accessor: "INSTRUCTION_NOTE",
                                            Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                            headerStyle: {
                                                "textAlign": "left",
                                                "backgroundColor": "lightgray"
                                            }
                                        }, {
                                            Header: "Sort index",
                                            accessor: "SORT_INDEX",
                                            style: {
                                                "textAlign": "right"
                                            },
                                            headerStyle: {
                                                "textAlign": "right",
                                                "backgroundColor": "lightgray"
                                            },
                                            maxWidth: 80
                                        }
                                    ]}/>}

                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </Col>
            )
        }
    }
}

export default OrderInfo;